function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
//
// ## Description
// A formatter for abstract tickable objects, such as notes, chords,
// tabs, etc.
import { Vex } from './vex';
import { Tickable } from './tickable';
import { Fraction } from './fraction';
export var TickContext = /*#__PURE__*/function (_Tickable) {
  _inherits(TickContext, _Tickable);

  var _super = _createSuper(TickContext);

  _createClass(TickContext, null, [{
    key: "getNextContext",
    value: function getNextContext(tContext) {
      var contexts = tContext.tContexts;
      var index = contexts.indexOf(tContext);
      return contexts[index + 1];
    }
  }]);

  function TickContext(options) {
    var _this;

    _classCallCheck(this, TickContext);

    _this = _super.call(this);
    _this.tickID = options && options.tickID;

    _this.setAttribute('type', 'TickContext');

    _this.currentTick = new Fraction(0, 1);
    _this.maxTicks = new Fraction(0, 1);
    _this.maxTickable = null; // Biggest tickable

    _this.minTicks = null; // this can remian null if all tickables have ignore_ticks

    _this.minTickable = null;
    _this.padding = 1; // padding on each side (width += padding * 2)

    _this.x = 0;
    _this.xBase = 0; // base x position without xOffset

    _this.xOffset = 0; // xBase and xOffset are an alternative way to describe x (x = xB + xO)

    _this.tickables = []; // Notes, tabs, chords, lyrics.

    _this.tickablesByVoice = {}; // Tickables indeced by voice number
    // Formatting metrics

    _this.notePx = 0; // width of widest note in this context

    _this.glyphPx = 0; // width of glyph (note head)

    _this.leftDisplacedHeadPx = 0; // Extra left pixels for displaced notes

    _this.rightDisplacedHeadPx = 0; // Extra right pixels for displaced notes

    _this.modLeftPx = 0; // Left modifier pixels

    _this.modRightPx = 0; // Right modifier pixels

    _this.totalLeftPx = 0; // Total left pixels

    _this.totalRightPx = 0; // Total right pixels

    _this.tContexts = []; // Parent array of tick contexts

    return _this;
  }

  _createClass(TickContext, [{
    key: "getTickID",
    value: function getTickID() {
      return this.tickID;
    }
  }, {
    key: "getX",
    value: function getX() {
      return this.x;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      this.xBase = x;
      this.xOffset = 0;
      return this;
    }
  }, {
    key: "getXBase",
    value: function getXBase() {
      return this.xBase;
    } // use of xBase and xOffset is optional, avoids offset creep

  }, {
    key: "setXBase",
    value: function setXBase(xBase) {
      this.xBase = xBase;
      this.x = xBase + this.xOffset;
    }
  }, {
    key: "getXOffset",
    value: function getXOffset() {
      return this.xOffset;
    }
  }, {
    key: "setXOffset",
    value: function setXOffset(xOffset) {
      this.xOffset = xOffset;
      this.x = this.xBase + xOffset;
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width + this.padding * 2;
    }
  }, {
    key: "setPadding",
    value: function setPadding(padding) {
      this.padding = padding;
      return this;
    }
  }, {
    key: "getMaxTicks",
    value: function getMaxTicks() {
      return this.maxTicks;
    }
  }, {
    key: "getMinTicks",
    value: function getMinTicks() {
      return this.minTicks;
    }
  }, {
    key: "getMaxTickable",
    value: function getMaxTickable() {
      return this.maxTickable;
    }
  }, {
    key: "getMinTickable",
    value: function getMinTickable() {
      return this.minTickable;
    }
  }, {
    key: "getTickables",
    value: function getTickables() {
      return this.tickables;
    }
  }, {
    key: "getTickablesForVoice",
    value: function getTickablesForVoice(voiceIndex) {
      return this.tickablesByVoice[voiceIndex];
    }
  }, {
    key: "getTickablesByVoice",
    value: function getTickablesByVoice() {
      return this.tickablesByVoice;
    }
  }, {
    key: "getCenterAlignedTickables",
    value: function getCenterAlignedTickables() {
      return this.tickables.filter(function (tickable) {
        return tickable.isCenterAligned();
      });
    } // Get widths context, note and left/right modifiers for formatting

  }, {
    key: "getMetrics",
    value: function getMetrics() {
      var width = this.width,
          glyphPx = this.glyphPx,
          notePx = this.notePx,
          leftDisplacedHeadPx = this.leftDisplacedHeadPx,
          rightDisplacedHeadPx = this.rightDisplacedHeadPx,
          modLeftPx = this.modLeftPx,
          modRightPx = this.modRightPx,
          totalLeftPx = this.totalLeftPx,
          totalRightPx = this.totalRightPx;
      return {
        width: width,
        // Width of largest tickable in context
        glyphPx: glyphPx,
        // Width of largest glyph (note head)
        notePx: notePx,
        // Width of notehead + stem
        leftDisplacedHeadPx: leftDisplacedHeadPx,
        // Left modifiers
        rightDisplacedHeadPx: rightDisplacedHeadPx,
        // Right modifiers
        modLeftPx: modLeftPx,
        modRightPx: modRightPx,
        totalLeftPx: totalLeftPx,
        totalRightPx: totalRightPx
      };
    }
  }, {
    key: "getCurrentTick",
    value: function getCurrentTick() {
      return this.currentTick;
    }
  }, {
    key: "setCurrentTick",
    value: function setCurrentTick(tick) {
      this.currentTick = tick;
      this.preFormatted = false;
    }
  }, {
    key: "addTickable",
    value: function addTickable(tickable, voiceIndex) {
      if (!tickable) {
        throw new Vex.RERR('BadArgument', 'Invalid tickable added.');
      }

      if (!tickable.shouldIgnoreTicks()) {
        this.ignore_ticks = false;
        var ticks = tickable.getTicks();

        if (ticks.greaterThan(this.maxTicks)) {
          this.maxTicks = ticks.clone();
          this.maxTickable = tickable;
        }

        if (this.minTicks == null) {
          this.minTicks = ticks.clone();
          this.minTickable = tickable;
        } else if (ticks.lessThan(this.minTicks)) {
          this.minTicks = ticks.clone();
          this.minTickable = tickable;
        }
      }

      tickable.setTickContext(this);
      this.tickables.push(tickable);
      this.tickablesByVoice[voiceIndex] = tickable;
      this.preFormatted = false;
      return this;
    }
  }, {
    key: "preFormat",
    value: function preFormat() {
      if (this.preFormatted) return this;

      for (var i = 0; i < this.tickables.length; ++i) {
        var tickable = this.tickables[i];
        tickable.preFormat();
        var metrics = tickable.getMetrics(); // Maintain max displaced head pixels from all tickables in the context

        this.leftDisplacedHeadPx = Math.max(this.leftDisplacedHeadPx, metrics.leftDisplacedHeadPx);
        this.rightDisplacedHeadPx = Math.max(this.rightDisplacedHeadPx, metrics.rightDisplacedHeadPx); // Maintain the widest note for all tickables in the context

        this.notePx = Math.max(this.notePx, metrics.notePx); // Maintain the widest note head

        this.glyphPx = Math.max(this.glyphPx, metrics.glyphWidth); // Total modifier shift

        this.modLeftPx = Math.max(this.modLeftPx, metrics.modLeftPx);
        this.modRightPx = Math.max(this.modRightPx, metrics.modRightPx); // Total shift

        this.totalLeftPx = Math.max(this.totalLeftPx, metrics.modLeftPx + metrics.leftDisplacedHeadPx);
        this.totalRightPx = Math.max(this.totalRightPx, metrics.modRightPx + metrics.rightDisplacedHeadPx); // Recalculate the tick context total width

        this.width = this.notePx + this.totalLeftPx + this.totalRightPx;
      }

      return this;
    }
  }, {
    key: "postFormat",
    value: function postFormat() {
      if (this.postFormatted) return this;
      this.postFormatted = true;
      return this;
    }
  }]);

  return TickContext;
}(Tickable);